var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServerLoadReduction = function SvgServerLoadReduction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32 1.567a1.54 1.54 0 0 0-.442-1.124A1.51 1.51 0 0 0 30.434 0a27.1 27.1 0 0 0-11.938 3.255.6.6 0 0 0-.313.576l.563 7.935a.293.293 0 0 1-.374.323l-3.53-5.486a.6.6 0 0 0-.689-.252.6.6 0 0 0-.226.126 25.7 25.7 0 0 0-8.008 14.897c-.046.297 0 1.267-.206 1.481L.712 27.87a2.43 2.43 0 0 0 0 3.435 2.463 2.463 0 0 0 3.43 0l5.007-5.01a25.86 25.86 0 0 0 15.48-7.213A26.25 26.25 0 0 0 32 1.567",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.998 1.567a1.54 1.54 0 0 0-.442-1.124A1.51 1.51 0 0 0 30.433 0a27.1 27.1 0 0 0-11.939 3.255.6.6 0 0 0-.313.576L18.264 5l.071 1 .31 4.374.924 12.549a25.9 25.9 0 0 0 5.06-3.842 26.25 26.25 0 0 0 7.369-17.514"
  })));
};
export default SvgServerLoadReduction;